import { useCallback } from "react"
import { useSetState } from "ahooks-v2"
import { createModel } from "hox"
// ==============================================
interface MapinfoArgs {
  // 是否保存点信息
  isPointInfoSave: boolean
  // 鼠标是否在Marker上
  isMouseOnMarker: boolean
}
function useMapinfo() {
  const [state, set] = useSetState<MapinfoArgs>({
    isPointInfoSave: false,
    isMouseOnMarker: false,
  })
  const setAllState = useCallback(
    (value: Partial<MapinfoArgs> | ((prevState: MapinfoArgs) => Partial<MapinfoArgs>)) => {
      set(value)
    },
    [set],
  )
  return {
    ...state,
    setAllState,
  }
}

export default createModel(useMapinfo)
